/**
 * MV2-1904: gatekeeper único pro fluxo de Conciliação de Pagamento.
 * Role `DASH_PAYMENT_RECONCILIATION` é atribuída manualmente por admin.
 * Esconde: botão "Conciliar pagamentos", coluna "Conciliação", botões no drawer
 * (conciliar manual / desfazer / reprocessar).
 */
export const hasReconciliationRole = (): boolean => {
  const user = JSON.parse(localStorage.getItem('auth-user') || 'null');
  return !!user?.permissions?.some(
    (permission: { role_id: string; status: boolean }) =>
      permission.role_id === 'DASH_PAYMENT_RECONCILIATION' && !!permission.status,
  );
};
